// extracted by mini-css-extract-plugin
export default {"columnHeader":"ColumnHeader_columnHeader__GIz7N"};